module.exports = __webpack_public_path__ + "img/014.aad9dce9.png";